var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDevelopment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "78.333px",
    height: "79.754px",
    viewBox: "0 0 78.333 79.754",
    enableBackground: "new 0 0 78.333 79.754",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_",
    display: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -109.333,
    y: -47.623,
    display: "inline",
    fill: "#891111",
    width: 457,
    height: 271
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    display: "inline"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -543.667,
    y: -439.167,
    fill: "#00598A",
    width: 1096,
    height: 857
  })), /*#__PURE__*/React.createElement("g", {
    id: "research",
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M58.887,78.922l-18.5-10.793V46.555l18.5-10.791l18.5,10.791v21.574L58.887,78.922z M41.387,67.555 l17.5,10.209l17.5-10.209V47.129l-17.5-10.208l-17.5,10.208V67.555z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M39.385,44.963l-18.5-10.791V12.599l18.5-10.792l18.5,10.792v21.574L39.385,44.963z M21.885,33.599 l17.5,10.208l17.5-10.208V13.173l-17.5-10.209l-17.5,10.209V33.599L21.885,33.599z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M39.386,31.485c-7.141,0-12.194-6.873-12.406-7.166l-0.208-0.287l0.203-0.292 c0.207-0.296,5.143-7.255,12.474-7.255c7.334,0,12.149,6.964,12.35,7.261l0.197,0.289l-0.205,0.284 C51.579,24.612,46.525,31.485,39.386,31.485z M28.014,24.021c1.033,1.289,5.544,6.464,11.372,6.464 c5.831,0,10.345-5.183,11.374-6.468c-0.988-1.301-5.329-6.532-11.312-6.532C33.453,17.485,29.024,22.717,28.014,24.021z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M39.385,30.485c-3.584,0-6.5-2.916-6.5-6.5s2.916-6.5,6.5-6.5c3.584,0,6.5,2.916,6.5,6.5 S42.969,30.485,39.385,30.485z M39.385,18.485c-3.032,0-5.5,2.468-5.5,5.5c0,3.033,2.468,5.5,5.5,5.5c3.034,0,5.5-2.467,5.5-5.5 C44.885,20.953,42.418,18.485,39.385,18.485z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M35.633,23.985h-0.399c0-2.454,1.697-4.451,4.151-4.451v1C37.481,20.534,35.633,22.082,35.633,23.985z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M19.883,78.922l-18.5-10.793V46.555l18.5-10.791l18.5,10.791v21.574L19.883,78.922z M2.383,67.555 l17.5,10.209l17.5-10.209V47.129l-17.5-10.208l-17.5,10.208V67.555z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M21.145,67.635c-0.484,0-2.18-0.115-3.663-1.598L10.79,59.34c-0.34-0.34-0.514-0.801-0.489-1.301 c0.024-0.479,0.231-0.938,0.584-1.291c0.712-0.713,1.929-0.756,2.591-0.096c0.669,0.686,1.45,1.317,1.729,1.412 c0.085-0.023,0.167-0.045,0.245-0.062c0.062-0.018,0.149-0.033,0.172-0.047l0,0c-0.002,0,0.073-0.104,0.091-0.576l-0.001-8.787 c0-0.852,0.805-1.545,1.794-1.545c0.989,0,1.795,0.693,1.795,1.545l-0.025,2.688c0.291-0.144,0.627-0.222,0.987-0.222 c0.894,0,1.652,0.504,1.907,1.198c0.244-0.112,0.522-0.178,0.817-0.178c0.84,0,1.541,0.521,1.694,1.207 c0.241-0.104,0.516-0.166,0.806-0.166c0.978,0,1.773,0.687,1.773,1.528V63.1c-0.002,0.062-0.214,4.525-5.964,4.531 C21.286,67.631,21.229,67.635,21.145,67.635z M24.713,57.1H23.71v-2.443v-1.08c0-0.264-0.338-0.49-0.725-0.49 c-0.387,0-0.726,0.229-0.726,0.49l-0.004,3.541H21.26v-4.342c0-0.387-0.457-0.713-0.999-0.713c-0.535,0-0.993,0.322-1.001,0.703 l-0.004,4.352h-0.957v-8.523c0-0.291-0.364-0.541-0.795-0.541c-0.431,0-0.794,0.25-0.794,0.547V57.4 c-0.04,1.142-0.414,1.438-1.047,1.58c-0.064,0.017-0.134,0.026-0.205,0.056l-0.24,0.039c-0.674,0-1.827-1.076-2.454-1.718 c-0.124-0.123-0.302-0.192-0.498-0.192c-0.243,0-0.489,0.104-0.675,0.291c-0.177,0.178-0.28,0.401-0.292,0.635 c-0.011,0.214,0.06,0.406,0.197,0.543l6.692,6.697c1.212,1.211,2.569,1.305,2.956,1.305l0.099-0.002 c4.811-0.002,5.01-3.407,5.017-3.553l-0.001-8.427c0-0.282-0.361-0.528-0.773-0.528c-0.413,0-0.775,0.246-0.775,0.528 L24.713,57.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M57.838,67.258c-1.93,0-3.5-1.568-3.5-3.5h1c0,1.379,1.121,2.5,2.5,2.5c1.377,0,2.5-1.121,2.5-2.5 c0-4.135,2.474-5.969,2.953-6.285c0.836-0.99,1.295-2.248,1.295-3.547c0-3.033-2.467-5.5-5.5-5.5c-3.031,0-5.5,2.467-5.5,5.5h-1 c0-3.584,2.916-6.5,6.5-6.5s6.5,2.916,6.5,6.5c0,1.564-0.562,3.074-1.586,4.256l-0.123,0.104 c-0.104,0.062-2.539,1.584-2.539,5.477C61.338,65.688,59.768,67.258,57.838,67.258z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M56.879,61.247h-1.875v-1h1.875c0.938,0,1.707-0.769,1.707-1.709c0-0.763-0.562-1.281-1.871-1.736 c-1.383-0.479-1.559-2-1.457-2.735c-0.004-2.092,1.752-3.851,3.912-3.851s3.916,1.759,3.916,3.918v0.959h-1v-0.959 c0-1.608-1.311-2.918-2.916-2.918c-1.608,0-2.916,1.31-2.916,2.918c-0.012,0.119-0.164,1.396,0.787,1.724 c0.694,0.242,2.545,0.884,2.545,2.683C59.586,60.032,58.372,61.247,56.879,61.247z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "design",
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M39.385,54.193c-16.623,0-29.184-13.715-29.309-13.854l-0.26-0.288l0.215-0.323 c0.09-0.136,9.287-13.661,29.354-13.661c20.069,0,29.266,13.588,29.356,13.725l0.213,0.324l-0.261,0.286 C68.568,40.542,56.008,54.193,39.385,54.193z M11.094,39.962C13,41.932,24.553,53.193,39.385,53.193 c14.833,0,26.385-11.209,28.292-13.17c-0.676-0.914-2.855-3.635-6.639-6.324c-4.25-3.025-11.459-6.631-21.653-6.631 c-10.193,0-17.4,3.589-21.652,6.6C13.953,36.344,11.771,39.051,11.094,39.962z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M39.385,53.663c-7.461,0-13.531-6.07-13.531-13.532c0-7.461,6.07-13.531,13.531-13.531 c7.461,0,13.532,6.07,13.532,13.531S46.846,53.663,39.385,53.663z M39.385,27.6c-6.91,0-12.531,5.621-12.531,12.531 c0,6.911,5.621,12.532,12.531,12.532c6.911,0,12.532-5.621,12.532-12.532C51.917,33.221,46.295,27.6,39.385,27.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M39.385,46.913c-3.738,0-6.781-3.043-6.781-6.782c0-3.739,3.043-6.781,6.781-6.781 c3.741,0,6.782,3.042,6.782,6.781C46.167,43.87,43.125,46.913,39.385,46.913z M39.385,34.35c-3.188,0-5.781,2.594-5.781,5.781 c0,3.188,2.594,5.782,5.781,5.782c3.187,0,5.782-2.595,5.782-5.782C45.167,36.944,42.572,34.35,39.385,34.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M10.947,72.038H1.822v-9.125h9.125V72.038z M2.822,71.038h7.125v-7.125H2.822V71.038z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M10.947,17.162H1.822V8.037h9.125V17.162z M2.822,16.162h7.125V9.037H2.822V16.162z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M76.947,17.162h-9.125V8.037h9.125V17.162z M68.822,16.162h7.125V9.037h-7.125V16.162z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M76.947,72.038h-9.125v-9.125h9.125V72.038z M68.822,71.038h7.125v-7.125h-7.125V71.038z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.447,
    y: 66.975,
    fill: "#FFFFFF",
    width: 23.875,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.885,
    y: 16.662,
    fill: "#FFFFFF",
    width: 1,
    height: 46.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.447,
    y: 12.1,
    fill: "#FFFFFF",
    width: 23.875,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.447,
    y: 12.1,
    fill: "#FFFFFF",
    width: 23.875,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.885,
    y: 16.662,
    fill: "#FFFFFF",
    width: 1,
    height: 46.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.447,
    y: 66.975,
    fill: "#FFFFFF",
    width: 23.875,
    height: 1
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "44.947,26.868 43.947,26.868 43.947,1.975 34.822,1.975 34.822,26.568 33.822,26.568  33.822,0.975 44.947,0.975  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "39.385,79.754 33.822,69.729 33.822,53.284 34.822,53.284 34.822,69.471 39.385,77.693  43.947,69.471 43.947,53.163 44.947,53.163 44.947,69.729  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M34.541,12.6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.322,
    y: 9.059,
    fill: "#FFFFFF",
    width: 10.125,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.322,
    y: 14.106,
    fill: "#FFFFFF",
    width: 10.125,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.322,
    y: 62.059,
    fill: "#FFFFFF",
    width: 10.125,
    height: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "dev",
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M39.649,1.6c0,0-19.667,15.834-19.667,33.833 c0,18,8.667,24.168,8.667,24.168h22c0,0,8.667-6.168,8.667-24.168C59.316,17.434,39.649,1.6,39.649,1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M63.98,43.477c-0.131-0.131-0.317-0.199-0.519-0.199c-0.426-0.002-0.771,0.346-0.771,0.771 c0,0-1.24,5.668-3.688,10.426c-0.229,0.443-0.354,1.1,0,1.451c0,0,0.311,0.359,1.222,0.57c1.229,0.285,2.815,0.631,4.106,1.086 c2.735,0.961,4.312,1.479,5.438,0.438C70.715,57.146,71.562,51.061,63.98,43.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M14.79,43.477c0.131-0.131,0.318-0.199,0.518-0.199c0.426-0.002,0.771,0.346,0.77,0.771 c0,0,1.242,5.668,3.685,10.426c0.229,0.443,0.354,1.1,0,1.451c0,0-0.308,0.359-1.219,0.57c-1.231,0.285-2.817,0.631-4.109,1.086 c-2.735,0.961-4.312,1.479-5.438,0.438C8.056,57.146,7.209,51.061,14.79,43.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M48.243,64.204L42.292,77.46c-0.328,0.972-1.248,1.67-2.33,1.67c-1.082,0-2-0.698-2.33-1.67 l-5.951-13.256H48.243z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M30.246,37.807c1.244,0,1.419-0.683,1.419-1.296c0-0.49-0.07-0.979-0.14-1.472 c-0.07-0.491-0.141-0.964-0.141-1.454c0-1.611,1.051-2.295,2.54-2.295h0.368v0.964h-0.315c-1.033,0-1.384,0.561-1.384,1.507 c0,0.402,0.053,0.822,0.122,1.243c0.07,0.438,0.123,0.858,0.123,1.331c0.018,1.121-0.473,1.682-1.262,1.893v0.035 c0.789,0.192,1.279,0.787,1.262,1.908c0,0.474-0.053,0.912-0.123,1.332c-0.069,0.438-0.122,0.842-0.122,1.263 c0,0.979,0.402,1.522,1.384,1.522h0.315v0.963h-0.368c-1.454,0-2.54-0.629-2.54-2.397c0-0.474,0.07-0.965,0.141-1.438 c0.069-0.475,0.14-0.943,0.14-1.418c0-0.543-0.175-1.296-1.419-1.296V37.807z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M35.643,42.379c0-0.648,0.438-1.104,1.051-1.104c0.613,0,1.033,0.455,1.033,1.104 c0,0.629-0.402,1.104-1.051,1.104C36.062,43.482,35.643,43.008,35.643,42.379z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M39.269,42.379c0-0.648,0.438-1.104,1.051-1.104c0.613,0,1.033,0.455,1.033,1.104 c0,0.629-0.401,1.104-1.052,1.104C39.688,43.482,39.269,43.008,39.269,42.379z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M42.895,42.379c0-0.648,0.438-1.104,1.051-1.104s1.033,0.455,1.033,1.104 c0,0.629-0.402,1.104-1.051,1.104C43.314,43.482,42.895,43.008,42.895,42.379z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M50.095,38.7c-1.244,0-1.419,0.753-1.419,1.296c0,0.473,0.07,0.945,0.141,1.418 c0.069,0.475,0.141,0.965,0.141,1.438c0,1.771-1.104,2.398-2.541,2.398h-0.367v-0.963h0.3c0.979-0.018,1.399-0.543,1.399-1.521 c0-0.422-0.067-0.824-0.123-1.264c-0.067-0.42-0.141-0.857-0.141-1.332c0-1.121,0.491-1.716,1.262-1.908v-0.035 c-0.771-0.211-1.262-0.771-1.262-1.893c0-0.473,0.07-0.893,0.141-1.331c0.056-0.421,0.123-0.841,0.123-1.243 c0-0.946-0.367-1.489-1.385-1.507h-0.314V31.29H46.4c1.489,0,2.558,0.684,2.558,2.295c0,0.49-0.067,0.963-0.14,1.454 c-0.069,0.49-0.142,0.981-0.142,1.472c0,0.613,0.176,1.296,1.42,1.296L50.095,38.7L50.095,38.7z"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dev_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M39.415,1.424c0,0-19.667,15.834-19.667,33.832 c0,18.004,8.667,24.172,8.667,24.172h22.033c0,0,8.666-6.168,8.666-24.172C59.114,17.258,39.415,1.424,39.415,1.424z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M63.778,43.303c-0.131-0.129-0.318-0.197-0.518-0.197c-0.426-0.002-0.771,0.346-0.77,0.771 c0,0-1.242,5.668-3.688,10.424c-0.229,0.445-0.354,1.102,0,1.453c0,0,0.309,0.357,1.219,0.57 c1.229,0.283,2.814,0.631,4.107,1.086c2.734,0.961,4.312,1.479,5.438,0.438C70.512,56.973,71.36,50.889,63.778,43.303z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M14.554,43.303c0.131-0.129,0.318-0.197,0.519-0.197c0.427-0.002,0.771,0.346,0.771,0.771 c0,0,1.242,5.668,3.685,10.424c0.229,0.445,0.354,1.102,0,1.453c0,0-0.308,0.357-1.219,0.57 c-1.229,0.283-2.816,0.631-4.108,1.086c-2.734,0.961-4.312,1.479-5.438,0.438C7.82,56.973,6.973,50.889,14.554,43.303z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M48.042,64.032l-5.974,13.256c-0.33,0.971-1.254,1.67-2.343,1.67c-1.082,0-2.002-0.699-2.33-1.67 l-5.951-13.256H48.042L48.042,64.032z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M30.01,37.631c1.244,0,1.419-0.684,1.419-1.297c0-0.488-0.07-0.98-0.14-1.471 c-0.07-0.492-0.143-0.965-0.143-1.455c0-1.611,1.052-2.295,2.54-2.295h0.368v0.965h-0.313c-1.032,0-1.385,0.561-1.385,1.506 c0,0.402,0.054,0.822,0.122,1.244c0.07,0.438,0.123,0.857,0.123,1.33c0.02,1.121-0.473,1.682-1.262,1.893v0.035 c0.789,0.193,1.278,0.787,1.262,1.91c0,0.477-0.053,0.914-0.123,1.334c-0.067,0.439-0.122,0.842-0.122,1.262 c0,0.98,0.402,1.523,1.385,1.523h0.314v0.963h-0.368c-1.454,0-2.54-0.629-2.54-2.398c0-0.473,0.07-0.965,0.143-1.438 c0.067-0.473,0.14-0.946,0.14-1.421c0-0.544-0.175-1.298-1.419-1.298L30.01,37.631L30.01,37.631z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M35.408,42.208c0-0.647,0.438-1.104,1.052-1.104c0.611,0,1.033,0.455,1.033,1.104 c0,0.629-0.402,1.104-1.053,1.104C35.827,43.311,35.408,42.836,35.408,42.208z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M39.034,42.208c0-0.647,0.438-1.104,1.054-1.104c0.615,0,1.037,0.455,1.037,1.104 c0,0.629-0.403,1.104-1.057,1.104C39.454,43.311,39.034,42.836,39.034,42.208z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M42.674,42.208c0-0.647,0.439-1.104,1.057-1.104s1.039,0.455,1.039,1.104 c0,0.629-0.402,1.104-1.059,1.104C43.095,43.311,42.674,42.836,42.674,42.208z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M49.893,38.524c-1.244,0-1.42,0.754-1.42,1.298c0,0.475,0.07,0.947,0.143,1.421 c0.068,0.473,0.139,0.965,0.139,1.438c0,1.77-1.104,2.396-2.539,2.396h-0.371v-0.963h0.3c0.981-0.02,1.401-0.543,1.401-1.523 c0-0.42-0.067-0.82-0.121-1.262c-0.069-0.42-0.141-0.855-0.141-1.334c0-1.123,0.489-1.717,1.262-1.91v-0.035 c-0.771-0.211-1.262-0.77-1.262-1.893c0-0.473,0.067-0.893,0.141-1.33c0.054-0.422,0.121-0.842,0.121-1.244 c0-0.945-0.366-1.488-1.383-1.506h-0.318v-0.965h0.354c1.489,0,2.559,0.684,2.559,2.295c0,0.49-0.068,0.963-0.141,1.455 c-0.07,0.49-0.141,0.979-0.141,1.471c0,0.613,0.176,1.297,1.418,1.297V38.524L49.893,38.524z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDevelopment);
export default __webpack_public_path__ + "static/media/icon-development.c895e9ff4dd33fbe71a43c1355434213.svg";
export { ForwardRef as ReactComponent };